export const useStyles = (theme) => ({
  listitemRoot: {
    display: "flex",
    [theme.breakpoints.down(650)]: {
      flexDirection: "column",
    },
  },
});
